import { PayloadAction } from '@reduxjs/toolkit';
import { TIITHash, TIITSignInStore, TSavedDocuments } from './types';
import { errorMessages } from '~/constants/errorMessages.ts';
import { TStoreErrorAction } from '../types';

export const saveIITFulfilledSignAction = (
  state: TIITSignInStore,
  action: PayloadAction<{
    unSavedDocuments?: TSavedDocuments[];
    uploadedDocuments?: TSavedDocuments[];
  }>
) => {
  state.isIITSignsLoaded = true;
  state.isSigning = false;
  state.isLoading = false;
  state.unSavedDocuments = action.payload?.unSavedDocuments || [];
  state.uploadedDocuments = action.payload?.uploadedDocuments || [];
};

export const startSigningFulfilledAction = (
  state: TIITSignInStore,
  action: PayloadAction<{ documentsToSign?: TIITHash[] }>
) => {
  const documentsToSign = action.payload?.documentsToSign;
  state.isSigning = false;
  state.isLoading = false;
  state.isIITSignsLoaded = true;
  if (documentsToSign?.length) {
    state.IITHashes = documentsToSign;
  }
};

export const startFilesSigningFulfilledAction = (
  state: TIITSignInStore,
  action: PayloadAction<{ documentsToSign?: TIITHash[] }>
) => {
  startSigningFulfilledAction(state, action);
  state.isSigning = true;
};

export const startSigningPendingAction = (state: TIITSignInStore) => {
  state.isSigning = true;
  state.isLoading = true;
  state.cloudKeyQRVerificationURL = 'https://';
  state.isCloudKeyQRVerificationModalOpen = false;
  if (state.IITHashes.length) state.IITHashes = [];
  if (state.IITSigns.length) state.IITSigns = [];
  state.isIITSignsLoaded = false;
  state.isPrivateKeyLoaded = false;
  state.error = null;
  state.hasError = false;
};

export const rejectedAction = (state: TIITSignInStore, action: TStoreErrorAction) => {
  state.error = action.error?.message || errorMessages.SERVICE_UNAVAILABLE;
  state.hasError = true;
  state.isLoading = false;
};
